export default "../css/336483f00294a9dfdbe0fa91d1d00afa.ttf";